import React from 'react';

function AutomatedMiscOverlay({ t, clientCodingRows, counsellorCodingRows }) {
  return (
    <div className="overlay-article">
      <h2 id="overlay-heading" className="about-title">{t('automated_misc_miti_title')}</h2>
      <article className="article-content">
        <p className="article-intro">
          This guide mirrors the coding reference used in the full-session feedback PDF. It summarizes the automated client MISC labels and counsellor MITI-style labels that AIMIE uses when AutoMISC annotates a saved transcript.
        </p>
        <section>
          <h3>Client MISC Codes</h3>
          <p>
            Client utterances are grouped into change talk, sustain talk, and neutral language. Codes ending in <strong>+</strong> indicate movement toward change, codes ending in <strong>-</strong> indicate movement toward maintaining smoking, and <strong>Neutral</strong> covers statements that do neither.
          </p>
          <figure className="overlay-figure">
            <table className="io-table" aria-label="Client MISC codes manual">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Category</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {clientCodingRows.map(([code, category, description]) => (
                  <tr key={code}>
                    <td>{code}</td>
                    <td>{category}</td>
                    <td>{description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <figcaption className="overlay-table-caption">
              Automated client-language labels used in AIMIE feedback reports.
            </figcaption>
          </figure>
        </section>
        <section>
          <h3 id="counsellor-miti-codes">Counsellor MITI Codes</h3>
          <p>
            Counsellor utterances are summarized into MI-adherent, MI-inconsistent, and other technique categories. These are the same code labels shown in the automated analytics and feedback documents.
          </p>
          <figure className="overlay-figure">
            <table className="io-table" aria-label="Counsellor MITI codes manual">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Category</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {counsellorCodingRows.map(([code, category, description]) => (
                  <tr key={code}>
                    <td>{code}</td>
                    <td>{category}</td>
                    <td>{description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <figcaption className="overlay-table-caption">
              Automated counsellor technique labels used in AIMIE feedback reports.
            </figcaption>
          </figure>
        </section>
      </article>
    </div>
  );
}

export default AutomatedMiscOverlay;
